<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <div class="admin-add-products fullheight">
        <v-toolbar dark :color="'#9e9e9e'">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            <h1
              class="header-tittle"
              :style="{ color: colorsGeneralSecondary }"
            >
              {{ title }}
            </h1>
          </v-toolbar-title>
        </v-toolbar>

        <Loader :dialog-loader="dialogLoader" message="Cargando..."></Loader>

        <v-container fluid>
          <v-form
            ref="form"
            v-model="isValid"
            lazy-validation
            @submit.prevent="submitForm"
          >
            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Nombre :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-text-field
                  v-model.trim="input.name"
                  :rules="validationRules.name"
                  required
                  placeholder="E.g. Agua"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Descripción :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-textarea
                  v-model.trim="input.description"
                  :rules="validationRules.description"
                  auto-grow
                  rows="1"
                  row-height="15"
                  value
                ></v-textarea>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Categoría :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-select
                  v-model="input.category_id"
                  :items="categories"
                  :rules="validationRules.category"
                  item-text="name"
                  item-value="id"
                  label="Selecciona categoría"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Subcategoría :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-select
                  v-model="input.sub_category_id"
                  :items="subCategories"
                  item-text="name"
                  item-value="id"
                  label="Selecciona subcategoría"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Ruta de Impresión :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-select
                  v-model="input.type_order_id"
                  :rules="validationRules.type_order_id"
                  :items="typeOrders"
                  item-text="name"
                  item-value="id"
                  label="Selecciona la ruta de impresión"
                ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >¿Es nuevo? :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-radio-group v-model="input.isNew" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >¿Mostrar en la seccion COMIDA? :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-radio-group v-model="input.canBeShowInFood" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Tipo de precio:</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-radio-group v-model="input.priceType" row>
                  <v-radio label="Unidad" value="unit"></v-radio>
                  <v-radio label="Peso (Kg)" value="weight"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Precio :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-text-field
                  v-model="input.price"
                  :rules="validationRules.price"
                  type="number"
                  suffix="‎€"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Stock :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="1" class="py-0 py-sm-1">
                <v-radio-group v-model="input.stock" row>
                  <v-radio label="Si" :value="1"></v-radio>
                  <v-radio label="No" :value="0"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Orden :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-text-field
                  :rules="validationRules.sort"
                  v-model="input.sort"
                  type="number"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Se puede compartir? :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-radio-group v-model="input.canBeShared" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Puede ser plato principal? :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-radio-group v-model="input.canBeMainCourse" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Tiene puntos de cocción? :</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-radio-group v-model="input.hasCookingPoints" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }">
                  ¿Se pueden seleccionar Ingredientes/Sabores? :
                </v-subheader>
              </v-col>
              <v-col cols="12" sm="3" class="py-0 py-sm-1">
                <v-radio-group v-model="input.hasMainIngredient" row>
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="4" sm="4"></v-col>
              <v-col
                cols="auto"
                sm="6"
                class="py-0 py-sm-1"
                v-if="input.hasMainIngredient"
              >
                <v-row>
                  <v-col cols="8" class="py-sm-1">
                    <v-text-field
                      type="number"
                      v-model="input.numberOfIngredients"
                      :rules="validationRules.numberOfIngredients"
                      required
                      label="¿Cuántos se pueden seleccionar?"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6" class="py-sm-1">
                    <v-subheader :style="{ color: formLabelTheme }"
                      >Ingredientes/Sabores</v-subheader
                    >
                  </v-col>
                  <v-col cols="2" class="ml-8 py-sm-1">
                    <v-subheader :style="{ color: formLabelTheme }"
                      >Precio</v-subheader
                    >
                  </v-col>
                </v-row>

                <v-row v-for="(ingredient, k) in input.ingredients" :key="k">
                  <v-col cols="6" class="py-sm-1">
                    <v-text-field
                      type="text"
                      v-model="ingredient.item"
                      :rules="validationRules.ingredient"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="2" sm="2" class="ml-8 py-sm-1">
                    <v-text-field
                      type="number"
                      v-model="ingredient.add_price"
                      :rules="validationRules.add_price"
                      suffix="‎€"
                    ></v-text-field>
                  </v-col>
                  <v-col cols="1" class="ml-8 mt-3 py-sm-1">
                    <button type="button" @click="removeIngredient(k)">
                      <font-awesome-icon
                        icon="minus-square"
                        :style="{ color: '#ea2222', fontSize: 20 }"
                      />
                    </button>
                  </v-col>
                  <v-col cols="8">
                    <v-row class="justify-center">
                      <v-avatar
                        @click="addIngredient(k)"
                        v-show="k === input.ingredients.length - 1"
                        color="primary"
                        size="36"
                      >
                        <font-awesome-icon
                          icon="plus-square"
                          :style="{ color: '#ffffff', fontSize: 20 }"
                        />
                      </v-avatar>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >¿El producto permite comentarios?</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-radio-group
                  v-model="input.isAllowComment"
                  row
                  :rules="validationRules.isAllowComment"
                >
                  <v-radio label="Si" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <!-- Product IG Stories -->
            <v-row>
              <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                <v-subheader :style="{ color: formLabelTheme }"
                  >Stories de producto</v-subheader
                >
              </v-col>
              <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                <v-row>
                  <v-col cols="3">
                    <v-radio-group v-model="input.isAllowProductStory" row>
                      <v-radio label="Si" :value="true"></v-radio>
                      <v-radio label="No" :value="false"></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col cols="9">
                    <v-btn
                      class="mt-3 gradient-border"
                      outlined
                      small
                      fab
                      color="white"
                      @click="storyDialog = true"
                    >
                      <v-icon color="black">mdi-camera</v-icon>
                    </v-btn>
                    <StoryDialog
                      v-if="storyDialog && input.productStory !== ''"
                      :openDialog.sync="storyDialog"
                      :storyUrl="input.productStory"
                    />
                  </v-col>
                  <v-col cols="12">
                    <FileInput
                      :IsUploaded="IsUploaded"
                      :storyUrl="input.productStory"
                      @uploadVideo="uploadVideo"
                      @deleteVideo="deleteVideo"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- Product IG Stories -->
            <v-row>
              <v-expansion-panels
                :accordion="allergensPanel.accordion"
                :popout="allergensPanel.popout"
                :inset="allergensPanel.inset"
                :multiple="allergensPanel.multiple"
                :focusable="allergensPanel.focusable"
                :disabled="allergensPanel.disabled"
                :readonly="allergensPanel.readonly"
                :flat="allergensPanel.flat"
                :hover="allergensPanel.hover"
                :tile="allergensPanel.tile"
              >
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    <span
                      class="allergens-expansion-panel-header"
                      :style="{ color: formLabelTheme }"
                      >Alérgenos</span
                    >
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Es vegetariano? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.isVegetarian" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Altramuces? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasAltramuces" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Apio? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasApio" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Cacahuetes? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasCacahuetes" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Crustaceos? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasCrustaceos" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Gluten? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasGluten" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Huevo? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasHuevo" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Lacteos? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasLacteos" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Mostaza? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasMostaza" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Pescado? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasPescado" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Sesamo? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasSesamo" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Soja? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasSoja" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12" sm="5" md="4" class="py-0 py-sm-1">
                        <v-subheader :style="{ color: formLabelTheme }"
                          >¿Tiene Sulfitos? :</v-subheader
                        >
                      </v-col>
                      <v-col cols="12" sm="7" md="8" class="py-0 py-sm-1">
                        <v-radio-group v-model="input.hasSulfitos" row>
                          <v-radio label="Si" :value="true"></v-radio>
                          <v-radio label="No" :value="false"></v-radio>
                        </v-radio-group>
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>

            <v-row>
              <v-col align="center">
                <div class="my-2 mr-5">
                  <v-btn
                    dense
                    outlined
                    :disabled="!isValid || IsUploaded"
                    :style="adminNavigationBackTheme"
                    type="submit"
                  >
                    Guardar
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import { firebase } from "@/firebaseConfig";
import {
  foodCollection,
  saveFood,
  updateFood,
  getLastFood
} from "@/collections/food";
import moment from "moment";
import Loader from "../../common/Loader";
import FileInput from "@/components/admin/product/productstory/FileInput";
import StoryDialog from "@/components/admin/product/productstory/StoryDialog";
import { orderBy } from "lodash";
import { typeOrdersCollection } from "@/collections/typeOrders";
import { categoriesCollection } from "@/collections/categories";
import { subCategoriesCollection } from "@/collections/subCategories";

export default {
  name: "product-food-dialog",
  components: {
    Loader,
    FileInput,
    StoryDialog
  },
  props: ["categorySelected"],
  data: () => ({
    itemId: "addFood",
    storyDialog: false,
    files: [],
    IsUploaded: false,
    dialog: false,
    title: "",
    isValid: false,
    validationRules: {
      name: [v => !!v || "Nombre es requerido"],
      numberOfIngredients: [v => !!v || "cantidad es requerido"],
      description: [v => !!v || "Descripción es requerido"],
      price: [
        v => !!v || "Precio es requerido",
        v => (!!v && parseInt(v) > 0) || "Por favor, introduce un precio válido"
      ],
      sort: [
        v => !!v || "Orden es requerido",
        v => (!!v && parseInt(v) > 0) || "Por favor, introduce un orden válido"
      ],
      category: [v => !!v || "Por favor, selecciona una categoría"],
      isAllowComment: [
        v =>
          v === true || v === false || "Por favor, selecciona una comentarios"
      ],
      add_price: [
        v =>
          (v !== undefined && parseFloat(v) > -1) ||
          "Por favor, introduce un Precio válido"
      ],
      ingredient: [v => !!v || "Ingredientes es requerido"]
    },
    foodCollection: [],
    categoriesCollection: [],
    subCategoriesCollection: [],
    typeOrders: [],
    productTypeId: "",
    input: {
      name: "",
      description: "",
      price: 1,
      canBeShowInFood: true,
      priceType: "unit",
      isAllowComment: false,
      hasAltramuces: false,
      hasSesamo: false,
      hasApio: false,
      hasLacteos: false,
      hasHuevo: false,
      hasSulfitos: false,
      hasSoja: false,
      hasCookingPoints: false,
      hasMainIngredient: false,
      ingredients: [
        {
          item: "",
          quantity: 1,
          add_price: parseFloat(0)
        }
      ],
      numberOfIngredients: 1,
      canBeShared: false,
      canBeMainCourse: false,
      isNew: false,
      isVegetarian: false,
      hasMostaza: false,
      hasCrustaceos: false,
      hasPescado: false,
      hasCacahuetes: false,
      hasGluten: false,
      stock: 1,
      sort: 1,
      category_id: "",
      sub_category_id: "",
      type_order_id: "",
      isAllowProductStory: false,
      productStory: ""
    },
    dialogLoader: true,
    allergensPanel: {
      accordion: false,
      popout: false,
      inset: false,
      multiple: false,
      disabled: false,
      readonly: false,
      focusable: false,
      flat: false,
      hover: false,
      tile: false
    }
  }),
  firestore() {
    return {
      foodCollection: foodCollection.orderBy("name"),
      categoriesCollection: categoriesCollection,
      subCategoriesCollection: subCategoriesCollection,
      typeOrders: typeOrdersCollection
    };
  },
  computed: {
    categories() {
      return this.categoriesCollection.filter(
        category => this.productTypeId === category.product_type_id
      );
    },

    subCategories() {
      return this.subCategoriesCollection.filter(
        subCat => this.input.category_id === subCat.category_id
      );
    }
  },
  mounted() {
    this.productTypeId = this.$store.state.productTypeIds.food;
  },
  methods: {
    deleteVideo(url) {
      firebase
        .storage()
        .refFromURL(url)
        .delete()
        .then(() => {
          this.files = [];
          this.input.productStory = "";
          this.showSuccessMessage("El video se ha eliminado correctamente");
        })
        .catch(err => console.log(err));
    },
    uploadVideo(filesData) {
      this.files = filesData;
      if (this.files) {
        if (this.files.size <= 20000000) {
          this.IsUploaded = true;
          firebase
            .storage()
            .ref(`${this.files.name}`)
            .put(this.files)
            .then(response => {
              response.ref
                .getDownloadURL()
                .then(downloadURL => {
                  this.input.productStory = downloadURL;
                  this.IsUploaded = false;
                  this.showSuccessMessage(
                    "El video se ha subido correctamente"
                  );
                })
                .catch(err => console.log(err));
            });
        } else {
          this.files = [];
          this.showErrorMessage(
            "El tamaño del video debe ser inferior a 20 MB"
          );
        }
      }
    },
    open(itemId) {
      this.dialog = true;
      this.itemId = itemId;

      if (itemId === "addFood") {
        setTimeout(() => {
          this.title = "Crear producto de tipo Comida";
        }, 100);

        this.dialogLoader = false;
        return;
      } else {
        this.title = "Editar producto de tipo Comida";
      }

      let self = this;
      setTimeout(() => {
        let cloneFoodCollection = JSON.parse(
          JSON.stringify(this.foodCollection)
        );
        let food = cloneFoodCollection.find(x => x.id === self.itemId);
        if (food) {
          self.input = food;
          self.input.priceType = food.priceType || "unit";
          if (self.input.ingredients.length > 0) {
            this.input.ingredients = food.ingredients.map(item => {
              return {
                item: item.item,
                quantity: item.quantity,
                add_price: item.add_price
              };
            });
          } else {
            this.input.ingredients = [
              {
                item: "",
                quantity: 1,
                add_price: parseFloat(0)
              }
            ];
          }
        }
        this.dialogLoader = false;
      }, 500);
    },
    close() {
      this.dialog = false;
      this.itemId = "addFood";
      this.files = [];

      this.input = {
        name: "",
        description: "",
        price: 1,
        canBeShowInFood: true,
        priceType: "unit",
        isAllowComment: false,
        hasAltramuces: false,
        hasSesamo: false,
        hasApio: false,
        hasLacteos: false,
        hasHuevo: false,
        hasSulfitos: false,
        hasSoja: false,
        hasCookingPoints: false,
        hasMainIngredient: false,
        ingredients: [{ item: "", quantity: 1, add_price: parseFloat(0) }],
        numberOfIngredients: 1,
        canBeShared: false,
        canBeMainCourse: false,
        isNew: false,
        isVegetarian: false,
        hasMostaza: false,
        hasCrustaceos: false,
        hasPescado: false,
        hasCacahuetes: false,
        hasGluten: false,
        stock: 1,
        sort: 1,
        category_id: "",
        sub_category_id: "",
        type_order_id: "",
        isAllowProductStory: false,
        productStory: ""
      };
      this.$refs.form.resetValidation();
    },
    async submitForm() {
      if (!this.$refs.form.validate()) {
        this.showErrorMessage("Revisa el formulario");
        return;
      }

      try {
        if (this.itemId === "addFood") {
          // check name is unique

          let found = this.foodCollection.some(
            x =>
              x.name.toLowerCase().trim() ===
              this.input.name.toLowerCase().trim()
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }

          // Create New
          await saveFood(this.buildProduct());
          await this.updateSortAfterCreate();
        } else {
          // check update unique name
          let found = this.foodCollection.some(
            x =>
              x.name.toLowerCase().trim() ===
                this.input.name.toLowerCase().trim() &&
              x.id.toLowerCase() !== this.itemId.toLowerCase()
          );
          if (found) {
            this.showErrorMessage("El nombre debe ser único");
            return;
          }

          // Update Existing
          await updateFood(this.itemId, this.buildProduct());

          // dynemic order update
          this.updateDynamicSort();
        }
        this.showSuccessMessage("Producto guardado");

        this.close();
      } catch (error) {
        this.setlogError(
          "save/update_food",
          "Obtained error message in submitForm()",
          error.stack,
          this.$options.name
        );
        this.showErrorMessage("Algo salió mal");
      }
    },
    updateDynamicSort() {
      let orderByFoodsCollection = this.sortProducts(this.foodCollection);

      let filterProducts = orderByFoodsCollection.filter(
        drink => this.input.category_id === drink.category_id
      );

      if (
        filterProducts &&
        filterProducts.length >= parseInt(this.input.sort)
      ) {
        let findIndex = filterProducts.findIndex(e => e.id === this.itemId);

        let movedArray = [
          ...this.array_move(
            [...filterProducts],
            findIndex,
            parseInt(this.input.sort) - 1
          )
        ];

        let cloneMovedArray = JSON.parse(JSON.stringify(movedArray));

        cloneMovedArray.forEach((item, index) => {
          item.sort = index + 1;
          updateFood(item.id, {
            sort: item.sort,
            updated_on: moment().format()
          }).catch(error => {
            this.setlogError(
              "update_food",
              "Obtained error message in updateDynamicSort()",
              error.stack,
              this.$options.name
            );
          });
        });
      } else {
        let findIndex = filterProducts.findIndex(e => e.id === this.itemId);

        let cloneOrderByFoodCollection = JSON.parse(
          JSON.stringify(filterProducts)
        );
        cloneOrderByFoodCollection.push(
          cloneOrderByFoodCollection.splice(findIndex, 1)[0]
        );

        let cloneMovedArray = JSON.parse(
          JSON.stringify(cloneOrderByFoodCollection)
        );

        cloneMovedArray.forEach((item, index) => {
          if (index === cloneMovedArray.length - 1) {
            item.sort = parseInt(this.input.sort);
          } else {
            item.sort = index + 1;
          }

          updateFood(item.id, {
            sort: item.sort,
            updated_on: moment().format()
          }).catch(error => {
            this.setlogError(
              "update_food",
              "Obtained error message in updateDynamicSort()",
              error.stack,
              this.$options.name
            );
          });
        });
      }
    },
    array_move(arr, old_index, new_index) {
      if (new_index >= arr.length) {
        let k = new_index - arr.length + 1;
        while (k--) {
          arr.push(undefined);
        }
      }
      arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
      return arr;
    },
    buildProduct() {
      let now = moment().format();
      let ingredients = this.input.ingredients.filter(item => {
        return item.item !== "";
      });
      let input = {
        name: this.input.name,
        description: this.input.description,
        price: this.input.price ? parseFloat(this.input.price) : null,
        hasAltramuces: this.input.hasAltramuces,
        hasSesamo: this.input.hasSesamo,
        hasApio: this.input.hasApio,
        hasLacteos: this.input.hasLacteos,
        hasHuevo: this.input.hasHuevo,
        hasSulfitos: this.input.hasSulfitos,
        hasSoja: this.input.hasSoja,
        hasCookingPoints: this.input.hasCookingPoints ? true : false,
        canBeShared: this.input.canBeShared ? true : false,
        canBeMainCourse: this.input.canBeMainCourse ? true : false,
        canBeShowInFood: this.input.canBeShowInFood ? true : false,
        priceType: this.input.priceType,
        isAllowComment: this.input.isAllowComment ? true : false,
        isAllowProductStory: this.input.isAllowProductStory ? true : false,
        productStory: this.input.productStory ? this.input.productStory : "",
        isNew: this.input.isNew,
        isVegetarian: this.input.isVegetarian,
        hasMostaza: this.input.hasMostaza,
        hasCrustaceos: this.input.hasCrustaceos,
        hasPescado: this.input.hasPescado,
        hasCacahuetes: this.input.hasCacahuetes,
        hasGluten: this.input.hasGluten,
        stock: this.input.stock,
        sort: parseInt(this.input.sort),
        category_id: this.input.category_id,
        sub_category_id: this.input.sub_category_id,
        hasMainIngredient: this.input.hasMainIngredient ? true : false,
        ingredients: ingredients.map(item => {
          item.add_price = parseFloat(item.add_price);
          return item;
        }),
        numberOfIngredients: parseInt(this.input.numberOfIngredients),
        type_order_id: this.input.type_order_id ? this.input.type_order_id : ""
      };
      console.log(input);
      return { ...input, product_type_id: this.productTypeId, updated_on: now };
    },
    async updateSortAfterCreate() {
      try {
        let querySnapshot = await getLastFood();

        let lastProduct = querySnapshot.docs[0].data();

        let lastProductId = querySnapshot.docs[0].id;

        let orderByFoodCollection = this.sortProducts(this.foodCollection);

        let filterProducts = orderByFoodCollection.filter(
          food => this.input.category_id === food.category_id
        );

        let findIndex = filterProducts.findIndex(e => e.id === lastProductId);

        let movedArray = [
          ...this.array_move(
            [...filterProducts],
            findIndex,
            parseInt(lastProduct.sort) - 1
          )
        ];

        let cloneMovedArray = JSON.parse(JSON.stringify(movedArray));

        cloneMovedArray.forEach((item, index) => {
          item.sort = index + 1;
          updateFood(item.id, {
            sort: item.sort,
            updated_on: moment().format()
          }).catch(error => {
            this.setlogError(
              "update_food",
              "Obtained error message in updateSortAfterCreate()",
              error.stack,
              this.$options.name
            );
          });
        });
      } catch (error) {
        this.setlogError(
          "get_last_food",
          "Obtained error message in updateSortAfterCreate()",
          error.stack,
          this.$options.name
        );
      }
    },
    sortProducts(products) {
      if (!products) {
        return [];
      }

      return (
        products &&
        orderBy(
          products,
          o => {
            return o.sort;
          },
          ["asc"]
        )
      );
    },
    addIngredient(index) {
      if (this.input.ingredients[index].item === "") {
        return;
      }
      this.input.ingredients.push({
        item: "",
        quantity: 1,
        add_price: parseFloat(0)
      });
    },
    removeIngredient(index) {
      this.input.ingredients.splice(index, 1);
    }
  }
};
</script>
